import { Link } from 'react-router-dom';
import { UserOutlined } from '@ant-design/icons';
import { Highlight } from '@/shared/ui/Highlight';
import { formatName } from '@/utils/search';
import type { SearchPatient } from '@/models/search';
import styles from '../styles/ResultRow.module.css';

export const PatientRow = ({
  patient,
  query,
}: {
  patient: SearchPatient;
  query: string;
}) => (
  <Link to={`/patients/${patient.uuid}`} className={styles.resultRow}>
    <div className={`${styles.resultIcon} ${styles.patient}`}>
      <UserOutlined />
    </div>
    <div className={styles.resultContent}>
      <span className={styles.resultPrimary}>
        <Highlight
          text={formatName(patient.firstName, patient.lastName)}
          query={query}
        />
      </span>
      {patient.medicalRecordNumber && (
        <span className={styles.resultSecondary}>
          MRN: <Highlight text={patient.medicalRecordNumber} query={query} />
        </span>
      )}
    </div>
    <span className={`${styles.typeBadge} ${styles.patient}`}>Patient</span>
  </Link>
);
